/**
 * Rough currency conversion for INSTRUCTOR-FACING estimates only ("NZ$90 is about A$81
 * today"). Never used to price, charge or display a buyer amount: real conversion happens
 * at Stripe's rate on the day each student pays.
 *
 * Mirrors EXCHANGE_RATES in backend-R1/src/utilities/currencyConverter.js (the venue-hire
 * estimate table), limited to the offered currencies. Change both together.
 */
const UNITS_PER_USD = {
    USD: 1.0,
    AUD: 1.52,
    EUR: 0.92,
    GBP: 0.79,
    CAD: 1.35,
    NZD: 1.68,
};

/**
 * @param {number} amount major units in `from`
 * @param {string} from ISO currency
 * @param {string} to ISO currency
 * @returns {number|null} approximate amount in `to` (major units), or null if unknown
 */
export const estimateConversion = (amount, from, to) => {
    if (!(amount > 0) || !UNITS_PER_USD[from] || !UNITS_PER_USD[to]) return null;
    return (amount / UNITS_PER_USD[from]) * UNITS_PER_USD[to];
};
